// !function(){"use strict";const t="[data-section-id]";customElements.get("recently-viewed")||customElements.define("recently-viewed",class extends HTMLElement{constructor(){super(),this.section=this.closest(t),this.howManyToShow=parseInt(this.dataset.limit)||3,this.target=this.dataset.target,this.wrapperId=this.dataset.wrapperId||this.id}connectedCallback(){Shopify.Products.showRecentlyViewed({howManyToShow:this.howManyToShow,wrapperId:this.wrapperId,section:this.section,target:this.target,onComplete:()=>{this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}))}})}})}();


!function(){"use strict";
  const t="[data-section-id]";
  customElements.get("recently-viewed")||customElements.define("recently-viewed",class extends HTMLElement{
    constructor(){
      super();
      this.section=this.closest(t);
      this.howManyToShow=parseInt(this.dataset.limit)||3;
      this.target=this.dataset.target;
      this.wrapperId=this.dataset.wrapperId||this.id;
      this._onPageShow = (e) => {
        if (e.persisted) {
          this.renderRecentlyViewed();
        }
      };
    }

    connectedCallback(){
      this.renderRecentlyViewed();
      window.addEventListener("pageshow", this._onPageShow);
    }

    disconnectedCallback(){
      window.removeEventListener("pageshow", this._onPageShow);
    }

    renderRecentlyViewed(){
      // purana content clear karo taaki duplicate na ho
      const wrapper = document.getElementById(this.wrapperId);
      if (wrapper) wrapper.innerHTML = "";

      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow,
        wrapperId: this.wrapperId,
        section: this.section,
        target: this.target,
        onComplete: () => {
          this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}));
        }
      });
    }
  });
}();